/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IPropertySchema } from '../../core/models/common/IPropertySchema';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Node } from '../../core/models/Node';
import { Schema } from '../../core/models/common/Schema';

/**
 * A command used to rename a schema property.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class RenamePropertyCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldPropertyName : string;

    public _newPropertyName : string;

    public constructor(parent? : any, oldPropertyName? : any, newPropertyName? : any) {
        if(((parent != null && parent instanceof <any>OasSchema) || parent === null) && ((typeof oldPropertyName === 'string') || oldPropertyName === null) && ((typeof newPropertyName === 'string') || newPropertyName === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldPropertyName===undefined) this._oldPropertyName = null;
            if(this._newPropertyName===undefined) this._newPropertyName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldPropertyName===undefined) this._oldPropertyName = null;
            if(this._newPropertyName===undefined) this._newPropertyName = null;
            (() => {
                this._oldPropertyName = oldPropertyName;
                this._newPropertyName = newPropertyName;
                this._parentPath = Library.createNodePath(parent);
            })();
        } else if(parent === undefined && oldPropertyName === undefined && newPropertyName === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldPropertyName===undefined) this._oldPropertyName = null;
            if(this._newPropertyName===undefined) this._newPropertyName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldPropertyName===undefined) this._oldPropertyName = null;
            if(this._newPropertyName===undefined) this._newPropertyName = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenamePropertyCommand] Executing.");
        this._doPropertyRename(document, this._oldPropertyName, this._newPropertyName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenamePropertyCommand] Reverting.");
        this._doPropertyRename(document, this._newPropertyName, this._oldPropertyName);
    }

    /**
     * Does the work of renaming a path from one name to another.
     * @param {Document} document
     * @param {string} from
     * @param {string} to
     * @private
     * @private
     */
    /*private*/ _doPropertyRename(document : Document, from : string, to : string) {
        let parent : OasSchema = <OasSchema>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        if(!this.isNullOrUndefined(parent.getProperty(to))) {
            return;
        }
        let property : OasSchema = <OasSchema>parent.removeProperty(from);
        if(this.isNullOrUndefined(property)) {
            return;
        }
        (<IPropertySchema><any>property).rename(to);
        parent.addProperty(to, property);
        let required : Array<string> = parent.required;
        let reqIdx : number = ModelUtils.isDefined(required)?required.indexOf(from):-1;
        if(reqIdx !== -1) {
            /* set */(parent.required[reqIdx] = to);
        }
    }
}
RenamePropertyCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenamePropertyCommand";
RenamePropertyCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




